import type {ComponentWithAs} from '@chakra-ui/system';

type Props<T extends any = any> = {
  tickFormatter: (value: T) => string;
  x: number;
  y: number;
  // TODO: strongly type payload
  payload: {
    value: T;
    [key: string]: any;
  };
};

const ChartXAxisTick: ComponentWithAs<'g', Props> = props => {
  const {x, y, payload, tickFormatter} = props;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor={`end`} fill={`var(--linx-colors-text-muted)`} style={{fontSize: `10px`}}>
        {tickFormatter(payload.value)}
      </text>
    </g>
  );
};

export default ChartXAxisTick;
